import React, {
    Component, forwardRef, useState, useEffect
  } from 'react';
  import { Breadcrumb } from "components";
  import { translate } from "react-switch-lang";
  import { AddBox, ArrowDownward } from '@material-ui/icons';
  import MaterialTable from 'material-table';
  import Check from '@material-ui/icons/Check';
  import ChevronLeft from '@material-ui/icons/ChevronLeft';
  import ChevronRight from '@material-ui/icons/ChevronRight';
  import Clear from '@material-ui/icons/Clear';
  import DeleteOutline from '@material-ui/icons/DeleteOutline';
  import Edit from '@material-ui/icons/Edit';
  import FilterList from '@material-ui/icons/FilterList';
  import FirstPage from '@material-ui/icons/FirstPage';
  import LastPage from '@material-ui/icons/LastPage';
  import Remove from '@material-ui/icons/Remove';
  import SaveAlt from '@material-ui/icons/SaveAlt';
  import Search from '@material-ui/icons/Search';
  import ViewColumn from '@material-ui/icons/ViewColumn';
  import CircularProgress from '@material-ui/core/CircularProgress';
  import TextField from '@material-ui/core/TextField';
  import Button from '@material-ui/core/Button';
  import Paper from '@material-ui/core/Paper';
  import Typography from '@material-ui/core/Typography';
  import { Tooltip } from '@material-ui/core';
  import DonutSmallOutlinedIcon from '@material-ui/icons/DonutSmallOutlined';
import ManageDateFilter from 'components/manageDateFilter';
  
  
 export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  };
  
  const dataTable = [
    {
      name: 'HBB',
      plan: 'Plan1',
      unit: '546'
    },
    {
      name: 'HBB',
      plan: 'Plan2',
      unit: '543'
    },
    {
      name: 'HBB',
      plan: 'Plan3',
      unit: '516'
    },
    {
      name: 'HBB',
      plan: 'Plan4',
      unit: '446'
    },
    {
      name: 'Baqati',
      plan: 'Plan1',
      unit: '542'
    },
    {
      name: 'Baqati',
      plan: 'Plan2',
      unit: '542'
    }, {
      name: 'Baqati',
      plan: 'Plan3',
      unit: '542'
    },
  
  ];
  
  const UploadFile = (props) => {
    const [loader, setLoader] = useState(false);
    const [staffId, setStaffId] = useState('11168386');
    const [data, setData] = useState();
    const [tableOpen, setTableOpen] = useState(false);
  
  
    const handleSubmit = async () => {
      // setLoader(true)
      // try {
      //   let res = await getIncentive(staffId)
      //   setData(res)
      // } catch (error) {
      //   console.log(error);
      // }
      // setLoader(false)
    };
    const handleTable = () => {
      setTableOpen(!tableOpen);
    };
  
    return (
      <>
      <Breadcrumb title={props.t("Import Sales Data")} />
        <div className="app-wrapper">
          {/* <div className="animated slideInUpTiny animation-duration-3">
            <div className="row">
              <div className="col-12">
                <Paper style={{ overflow: 'hidden', marginTop: 10, padding: 25 }} elevation={5}>
                  <div style={{ display: "flex" }}>
                    <Typography>Select file to upload</Typography>
                    <input
                          // ref={ref}
                          type="file"
                          id="bulkVaccineFileUpload"
                          // hidden
                          // onChange={(e) => handleFilePicker(e)}
                        />
                    <Button variant="contained" color="primary"
                      onClick={handleSubmit}
                      style={{ marginLeft: 10, marginRight: 10 }}>
                      Search
                    </Button>
                  </div>
                </Paper>
              </div>
            </div>
          </div> */}
  
          <div className="animated slideInUpTiny animation-duration-3">
            <div className="row">
              <div className="col-12">
                <Paper style={{ overflow: 'hidden', marginTop: 10, padding: 25 }} elevation={5}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span><h5>{props.t("Select file to import")}</h5></span>
                    <div style={{ maxWidth: 250 }}>
                      <input
                        // ref={ref}
                        type="file"
                        id="bulkVaccineFileUpload"
                      />
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      style={{ marginLeft: 10, marginRight: 10 }}
                    >{props.t("Upload")}
                      
  
                    </Button>
                  </div>
                </Paper>
              </div>
            </div>
            <Paper
              style={{
                height: 700, overflow: 'hidden', marginTop: 10, padding: 25, alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column'
              }}
              elevation={5}
            >
              {/* {loader ? <div
                style={{
                  height:
                    props.width >= 1200
                      ? "calc(100vh - 259px)"
                      : "calc(100vh - 238px)"
                }}
              >
                <CircularProgress />
              </div> : (data ? */}
              {/* <> */}
              {/* <Tooltip title="Chart View">
                      <Button style={{ display: 'flex', alignSelf: 'baseline' }}
                        onClick={handleTable}
                      ><DonutSmallOutlinedIcon /></Button>
                    </Tooltip> */}
              <div style={{width: '100%'}} className="mb-4">
              <ManageDateFilter />
              </div>
  
              <MaterialTable
                style={{ width: '100%', marginTop: 10 }}
                icons={tableIcons}
                columns={[
                  { title: props.t("Product Name"), field: 'name' },
                  { title: props.t("Plan"), field: 'plan' },
                  { title: props.t("Sold Units"), field: 'unit' },
                ]}
                data={dataTable}
                options={{
                  search: false
                }}
                title={props.t("Data failed to upload") }
              />
              {/* </> :
                <>
                  <Typography variant="h5" component="h3" >
                    Select file to upload
                  </Typography>
                </>)
              } */}
            </Paper>
          </div>
        </div>
      </>
    );
  };
  
  export default translate(UploadFile);
  